<script>
export default {
  name: 'FacebookIcon'
}
</script>

<template lang="pug">
svg.facebook-icon(
  width='10'
  height='19'
  viewbox='0 0 10 19'
  xmlns='http://www.w3.org/2000/svg'
)
  path(
    d='M6.4909 19V10.3332H9.4392L9.8807 6.95557H6.4909V4.79917C6.4909 3.82128 6.7661 3.15487 8.1873 3.15487L10 3.15409V0.133125C9.6865 0.0919628 8.6105 0 7.3586 0C4.7451 0 2.9559 1.57405 2.9559 4.46467V6.95557H0V10.3332H2.9559V19H6.4909Z'
  )
</template>

<style lang="stylus" scoped></style>
